// extracted by mini-css-extract-plugin
export default {"header":"header--Mdr1M","logo":"logo--hUNsm"};